import type { GetOversightAssessmentByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetOversightAssessmentByIdArgs = {
  Id: string;
};

export const useLazyGetOversightAssessmentById = createLazyQueryHook<
  UseLazyGetOversightAssessmentByIdArgs,
  GetOversightAssessmentByIdResponseRow[],
  GetOversightAssessmentByIdQuery
>({
  trpcQuery: (client, { Id }) =>
    client.frontend.oversight.getById.query({ id: Id }),
  mapTrpcDataToGraphQL: (data) => ({ oversight_assessment: data }),
  graphqlDocument: GetOversightAssessmentByIdDocument,
  graphqlVariables: ({ Id }) => ({ Id }),
});
